const updates = [
  { time: '10分钟前', title: '某顶流艺人深夜发文回应近期争议，评论区瞬间炸锅', tag: '吃瓜', tagColor: 'accent' as const },
  { time: '28分钟前', title: '2026上半年手机销量排行榜出炉，国产机型包揽前三', tag: '科技', tagColor: 'primary' as const },
  { time: '1小时前', title: '多地发布高温红色预警，防暑降温实用指南导航汇总', tag: '民生', tagColor: 'secondary' as const },
  { time: '2小时前', title: '热门综艺节目录制现场突发状况，节目组紧急发声明', tag: '吃瓜', tagColor: 'accent' as const },
  { time: '3小时前', title: '某电商平台618预售数据创历史新高，导航123直达会场', tag: '购物', tagColor: 'primary' as const },
  { time: '4小时前', title: '国际金价大幅波动，投资理财专家建议关注这些导航入口', tag: '财经', tagColor: 'secondary' as const },
  { time: '5小时前', title: '某知名游戏厂商发布会定档，新游预告引发玩家热议', tag: '游戏', tagColor: 'primary' as const },
  { time: '6小时前', title: '暑期旅游旺季来临，热门目的地酒店机票比价导航更新', tag: '出行', tagColor: 'secondary' as const },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">最新快讯</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            实时追踪全网热点，吃瓜、科技、购物等资讯一网打尽
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className="group relative flex items-start gap-4 pb-5 mb-5 border-b border-background-200/50 last:border-0 last:mb-0 last:pb-0 cursor-pointer"
            >
              <div className="relative mt-0.5">
                <div className="w-2 h-2 rounded-full bg-primary-400 mt-1.5 flex-shrink-0"></div>
                {i < updates.length - 1 && (
                  <div className="absolute top-4 left-1 w-px h-full bg-background-200"></div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${
                    item.tagColor === 'primary' ? 'bg-primary-100 text-primary-700' :
                    item.tagColor === 'accent' ? 'bg-accent-100 text-accent-700' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-medium text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 leading-snug">
                  {item.title}
                </h3>
              </div>
              <span className="whitespace-nowrap text-xs text-foreground-400 mt-0.5 flex-shrink-0">
                {item.time}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}